import { Params } from '@angular/router';

export function resolveVkBindWidgetId(params: Params): string | null {
  const direct = params['vk_bind_widget'];
  if (direct) {
    return String(direct);
  }

  const hashFromVk = params['hash'];
  if (hashFromVk != null && hashFromVk !== '') {
    const fromHash = parseHashString(String(hashFromVk), 'vk_bind_widget');
    if (fromHash) {
      return fromHash;
    }
  }

  if (typeof window !== 'undefined' && window.location.hash) {
    return parseHashString(window.location.hash, 'vk_bind_widget');
  }

  return null;
}

function parseHashString(hash: string, key: string): string | null {
  const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!normalized) {
    return null;
  }
  return new URLSearchParams(normalized).get(key);
}
